import ticketAdapter from '@/adapters/ticket';

export default (el) => ({
  id: String(el.id),
  status: el.combinedStatus || '',
  tickets: (el.tickets || []).map(ticketAdapter),
  expiration: el.expiration_date ? new Date(el.expiration_date) : null,
  created: el.date_created ? new Date(el.date_created) : null,
  payed: el.date_payed ? new Date(el.date_payed) : null,
});
